module.exports = __webpack_public_path__ + "static/media/famalicao.0adf4918.webp";